<template>
  <div class="card shadow-sm mb-4 border-0">
    <!-- Header -->
    <div class="card-header bg-light d-flex justify-content-between align-items-center">
      <h5 class="mb-0 text-primary">
        Producto Final Bulk
      </h5>
      <span class="badge bg-secondary">ID #{{ producto.id }}</span>
    </div>

    <!-- Body -->
    <div class="card-body">
      <div class="row g-3">

        <div class="col-md-6">
          <small class="text-muted">Tipo Producto</small>
          <div class="h5 mb-0">{{ producto.tipo_producto }}</div>
        </div>

        <div class="col-md-6">
          <small class="text-muted">Materia Prima</small>
          <div class="h5 mb-0">{{ producto.materia_prima?.codigo || '-' }}</div>
        </div>

        <div class="col-md-6">
          <small class="text-muted">Lote Producción</small>
          <div class="h5 mb-0">{{ producto.codigo }}</div>
        </div>

        <div class="col-md-6">
          <small class="text-muted">Stock Disponible</small>
          <div class="h5 mb-0 fw-semibold" :class="{
            'text-success': producto.stockDisponible > 0,
            'text-danger': producto.stockDisponible === 0
          }">
            {{ producto.stockDisponible }} {{ producto.unidad_medida }}
          </div>
        </div>


      </div>
    </div>

    <!-- Footer -->
    <div class="card-footer d-flex justify-content-end bg-white border-top-0">
      <slot name="footer">
        <!-- Opcional Footer si se quiere -->
      </slot>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  name: "ProductoFinalCard",
  data() {
    return {
      productoLocal: null
    };
  },
  props: {
    producto: {
      type: Object,
      required: true
    },
    producto_id: {
      type: Number,
      required: true
    }
  },
  created() {
    if (this.producto) {
      this.productoLocal = this.producto;
    } else {
      axios.get(`/producto_final_bulk/${this.producto_id}`)
        .then(response => {
          this.productoLocal = response.data;
        })
        .catch(error => {
          console.error("Error fetching producto:", error);
        });
    }
  },

};
</script>

<style scoped>
.card {
  border-radius: 0.75rem;
  background-color: #ffffff;
  transition: box-shadow 0.3s ease;
}

.card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.08);
}

.card-header {
  font-weight: 600;
  font-size: 1.1rem;
}

.badge {
  font-size: 0.75rem;
}

.card-body small {
  color: #6c757d;
  font-size: 0.75rem;
}

.card-body .h5 {
  font-weight: 500;
  color: #212529;
}

.card-footer {
  font-size: 0.9rem;
}
</style>